import SingleSelectInputBox from 'generics/components/single-select/native/input-box';
import CSSNumberValueControl from 'generics/components/css-number-value-control/native';

const FIT_OPTIONS = [{
  label: 'Fill and crop',
  value: 'cover'
}, {
  label: 'Show whole image',
  value: 'contain'
}];

const RATIO_OPTIONS = [{
  label: 'Square',
  value: '1 / 1'
}, {
  label: 'Landscape (4:3)',
  value: '4 / 3'
}, {
  label: 'Wide (16:9)',
  value: '16 / 9'
}, {
  label: 'Banner (3:1)',
  value: '3 / 1'
}];

const MAX_ITEMS_PER_VIEW = 8;

function getOptionIndex(options, value) {

  for (let index = 0; index < options.length; index++) {

    if (options[index].value === value) {
      return index;
    }

  }

  return 0;

}

/** How many items show at once and how each image fills its item. Writes into the shared settings object. */
class CarouselItemSettings {

  constructor(configuration) {

    this.settings = configuration.settings;
    this.onChange = configuration.onChange;

    this.itemsPerViewInput = new CSSNumberValueControl({
      value: this.settings.itemsPerView,
      onChange: this.handleItemsPerViewInput.bind(this)
    });

    this.imageFitSelect = new SingleSelectInputBox({
      placeholder: 'Select image fit',
      options: FIT_OPTIONS,
      selectedOptionIndices: [getOptionIndex(FIT_OPTIONS, this.settings.imageFit)],
      onChange: this.handleImageFitChange.bind(this)
    });

    this.imageRatioSelect = new SingleSelectInputBox({
      placeholder: 'Select image shape',
      options: RATIO_OPTIONS,
      selectedOptionIndices: [getOptionIndex(RATIO_OPTIONS, this.settings.imageRatio)],
      onChange: this.handleImageRatioChange.bind(this)
    });

  }

  handleItemsPerViewInput(value) {

    const count = parseInt(value, 10);

    if (isNaN(count) === true) {
      return;
    }

    if (count < 1 || count > MAX_ITEMS_PER_VIEW) {
      return;
    }

    this.settings.itemsPerView = count;
    this.onChange();

  }

  handleImageFitChange(selection) {

    this.settings.imageFit = selection.values[0];
    this.onChange();

  }

  handleImageRatioChange(selection) {

    this.settings.imageRatio = selection.values[0];
    this.onChange();

  }

}

export default CarouselItemSettings;
